export enum CaptionsViewMode {
    Short,
    Long,
}

export enum HintsViewMode {
    Hide,
    Show,
}

export const captionsViewModeKey = "ViewMode:CaptionsViewMode";
export const hintsViewModeKey = "ViewMode:HintsViewMode";
export const menuItemInfosKey = "ViewMode:menuItemInfos";
